import BaseTableController from './base_table_controller';

// dp_id 1991 — data_grid: { rows: [{ country, employee_count }] }
export default class extends BaseTableController {
  static values = { countryOptions: Array };

  searchableFields = ['country'];

  connect() {
    const rows = this.initialDataValue?.rows;
    this.rows =
      Array.isArray(rows) && rows.length > 0
        ? rows.map((r) => ({
            country: r.country ?? '',
            employee_count: r.employee_count ?? null,
          }))
        : [this.emptyRow()];
    this.renderRows();
    this.syncHiddenField();
  }

  emptyRow() {
    return { country: '', employee_count: null };
  }

  updateField(event) {
    const el = event.currentTarget;
    const index = parseInt(el.dataset.rowIndex, 10);
    const field = el.dataset.field;
    this.rows[index][field] =
      el.type === 'number' ? (el.value === '' ? null : parseInt(el.value, 10)) : el.value;
    this.syncHiddenField();
  }

  buildRow(row, index) {
    const tr = document.createElement('tr');

    tr.appendChild(
      this.buildSelectCell(row, index, 'country', this.countryOptionsValue, { fullWidth: true })
    );

    const countTd = document.createElement('td');
    const countInput = document.createElement('input');
    countInput.type = 'number';
    countInput.min = '0';
    countInput.step = '1';
    countInput.placeholder = '0';
    countInput.className = 'form-control w-100';
    countInput.dataset.rowIndex = index;
    countInput.dataset.field = 'employee_count';
    countInput.dataset.action = `input->${this.identifier}#updateField`;
    if (row.employee_count !== null && row.employee_count !== undefined) {
      countInput.value = row.employee_count;
    }
    countTd.appendChild(countInput);
    tr.appendChild(countTd);

    tr.appendChild(this.buildRemoveButton(index));

    return tr;
  }
}
